<template>
    <div>
        <header-nav :cur="8" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">资源</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">资源共享</div>
                        <div class="newbot">汇集知识碎片，解决学习难题</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 资源列表 -->
        <div class="navtab">
            <div class="listbox">
				<div class="wd_cont">
				  <img src="../../assets/img/question/ts_iconn.svg"/>
				  <p>暂无数据,正在更新中...</p>
				</div>
                <!-- <div class="libox" v-for="(item, index) in files" :key="index">
                    <div class="top">
                        <span>{{ item.title }}</span>
                        <img src="../../assets/img/resource/sour.svg" alt="" />
                    </div>
                    <div class="cont ignore">{{ item.content }}</div>
                    <div class="version">
                        <span class="span">当前版本：v1.0</span>
                        <span class="span1">下载量：{{item.downloadCount}}次</span>
                    </div>
                    <div class="time">更新日期：{{ item.createTime }}</div>
                </div> -->
            </div>
        </div>
        <!-- 分页 -->
<!-- 	 	<v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum' @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
 -->	 	
        <footer-nav />
    </div>
</template>
<script>
/* import pagination from '@/components/common/pagination' */
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        /* 'v-pagination': pagination, */
        'header-nav':headerNav,
        'footer-nav':footerNav,
    },
    data() {
        return {
			total:1,
			pageCount:1,
			pageSize:12,
			pageNum:1,
		    files:[],
			queryParams: {
			  pageNum: 1,
			  pageSize: 9,
			  articleTypeId:1,
			  courseName:null,
			  parentSubjectId:null,
			  subjectId:null,
			},
        };
    },
	created() {
		this.getList();
	},
	methods:{
		pagechange(currentPage){
			console.log(currentPage);
		    this.queryParams.pageNum=currentPage;
		    // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		    this.getList();
		},
		getList(){
			this.$http.get(this.$api.url +'/papi/download_file/list',{params:this.queryParams}).then((response) => {
			    this.files=[];
			    this.files = response.data.rows;	
				this.total = response.data.total;
				
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
	}
};
</script>
<style lang="less" scoped>
   // 公共
   .navtab {
       width: 1280px;
       margin: 0 auto;
   }
   .color {
       color: #2961EF !important;
   }
   .ignore {
       overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-box-orient: vertical;
       -webkit-line-clamp: 2;
   }
   // 搜索
   .nav {
       background: #f7f8fa;
       width: 100%;
       height: 177px;
       .top {
           display: block;
           font-size: 16px;
           font-weight: 300;
           color: #777777;
           padding: 19px 0 24px;
           .infor {
               color: #2961EF;
           }
       }
       .newbox {
           display: flex;
           justify-content: space-between;
           align-items: center;
           .newtop {
               font-size: 26px;
               color: #000000;
               margin-bottom: 5px;
           }
           .newbot {
               font-size: 16px;
               color: #888888;
           }
           .input {
               width: 497px;
               height: 59px;
               background: #ffffff;
               box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
               border-radius: 30px;
               position: relative;
               input {
                   border: none;
                   position: absolute;
                   left: 30px;
                   top: 0;
                   height: 59px;
                   line-height: 59px;
                   width: 365px;
                   font-size: 16px;
                   font-weight: 300;
                   color: #777777;
               }
               .select {
                   position: absolute;
                   right: 12px;
                   top: 8px;
                   width: 74px;
                   height: 43px;
                   line-height: 43px;
                   background: #2961EF;
                   border-radius: 30px;
                   font-size: 16px;
                   font-weight: 300;
                   color: #ffffff;
                   text-align: center;
               }
           }
       }
   }
   // 资源列表
   .listbox {
       display: flex;
       flex-wrap: wrap;
       margin-top: 28px;
       .libox {
           margin-bottom: 20px;
           width: 21%;
           margin-right: 2%;
           background: #fcfcfc;
           border-radius: 5px 5px 5px 5px;
           padding: 15px;
           border: 1px solid #f1f1f1;
           &:nth-child(4n) {
               margin-right: 0;
           }
           .top {
               display: flex;
               align-items: center;
               justify-content: space-between;
               span {
                   width: 106px;
                   height: 29px;
                   line-height: 29px;
                   text-align: center;
                   background: #f0f7ff;
                   border-radius: 5px 5px 5px 5px;
                   font-size: 14px;
                   color: #2961EF;
               }
           }
           .cont {
               font-size: 16px;
               color: #333333;
               margin: 10px 0;
               line-height: 30px;
           }
           .version {
               display: flex;
               justify-content: space-between;
               align-items: center;
               .span {
                   font-size: 14px;
                   color: #2961EF;
               }
               .span1 {
                   font-size: 12px;
                   color: #7dbeff;
               }
           }
           .time {
               font-size: 14px;
               color: #999999;
               margin-top: 5px;
           }
       }
   }
   // 分页
   .paging {
       width: 534px;
       height: 50px;
       background: #fafafa;
       border-radius: 37px 37px 37px 37px;
       margin: 35px auto;
       display: flex;
       align-items: center;
       justify-content: space-around;
       text-align: center;
       border: 1px solid #e1e1e1;
       div {
           height: 50px;
           line-height: 50px;
           border-right: 1px solid #e1e1e1;
           width: 20%;
           font-size: 16px;
           color: #888888;
           &:nth-child(5) {
               border: none;
           }
       }
   }
   .wd_cont{
       width: 800px;
       height: 400px;
       display: block;
       margin: 0 auto;
       img{
           width: 120px;
           height: auto;
           display: block;
           margin: 100px auto 0 auto;
           opacity: 0.5;
       }
       p{
           width: 100%;
           height: auto;
           line-height: 80px;
           font-size: 24px;
           font-weight: bold;
           color: #999;
           text-align: center;
           opacity: 0.7;
       }
   }
</style>